'use client';
import type { ReactElement } from 'react';
export interface FlowchartUnresolvedOverlayProps {
    accent: string;
}
export function FlowchartUnresolvedOverlay({ accent, }: FlowchartUnresolvedOverlayProps): ReactElement {
    return (
    <span style={{
            position: 'absolute',
            inset: 3,
            borderRadius: 10,
            border: `1.5px dashed color-mix(in srgb, ${accent} 70%, transparent)`,
            pointerEvents: 'none',
        }}/>
    );
}
